import VueI18n from "vue-i18n";
import { SensorLang } from "@/views/viz/sensor-strings";

export function applyEmbedLocale(i18n: VueI18n, lang: SensorLang): void {
    i18n.locale = lang;
}
